import { supabase } from "@/integrations/supabase/client";

/**
 * Merge a set of attributes for the currently-logged-in user.
 * Latest non-null wins; nulls/empty strings/missing keys leave existing values intact.
 * Only fires when called — never on partial submissions.
 * Silently no-ops if not authenticated.
 */
export async function upsertUserAttributes(attrs: Record<string, unknown>) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    // Strip undefined / empty string keys so they don't overwrite existing data
    const clean: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(attrs)) {
      if (v === undefined) continue;
      if (typeof v === "string" && v.trim() === "") continue;
      clean[k] = v;
    }
    if (Object.keys(clean).length === 0) return;
    await supabase.rpc("upsert_user_attributes" as any, { p_attrs: clean as any });
  } catch (err) {
    console.warn("[userAttributes] upsert failed", err);
  }
}